import { render, staticRenderFns } from "./HistVal.vue?vue&type=template&id=bb713778&scoped=true&"
import script from "./HistVal.vue?vue&type=script&lang=js&"
export * from "./HistVal.vue?vue&type=script&lang=js&"
import style0 from "./HistVal.vue?vue&type=style&index=0&id=bb713778&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb713778",
  null
  
)

export default component.exports